module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-circular-progress",
    style: ({
      'width': _vm.size + 'px',
      'height': _vm.size + 'px'
    })
  }, [(_vm.mode === 'indeterminate') ? _c('circular', {
    attrs: {
      "size": _vm.size,
      "color": _vm.color,
      "borderWidth": _vm.strokeWidth
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode === 'determinate') ? _c('svg', {
    staticClass: "mu-circular-progress-determinate",
    style: (_vm.circularSvgStyle),
    attrs: {
      "viewBox": '0 0 ' + _vm.size + ' ' + _vm.size
    }
  }, [_c('circle', {
    staticClass: "mu-circular-progress-determinate-path",
    style: (_vm.circularPathStyle),
    attrs: {
      "r": _vm.radius,
      "cx": _vm.size / 2,
      "cy": _vm.size / 2,
      "fill": "none",
      "stroke-miterlimit": "20",
      "stroke-width": _vm.strokeWidth
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80ef5bee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/circularProgress/circularProgress.vue
// module id = 460
// module chunks = 1